import { DYNAMIC_DATA_SPLITTER, EMPTY_STRING } from "utils/Constants";

export default {
    measure: {
        row: 0,
        column: 1,
        isMeasure: true,
        format: "in",
        splitBy: "in",
        separator: DYNAMIC_DATA_SPLITTER
    },
    weightKg: {
        row: 0,
        column: 5,
        splitBy: EMPTY_STRING,
        separator: DYNAMIC_DATA_SPLITTER
    },
    weightLbs: {
        row: 1,
        column: 5,
        splitBy: EMPTY_STRING,
        separator: DYNAMIC_DATA_SPLITTER
    },
    vWeightFt3: {
        row: 0,
        column: 6,
        splitBy: EMPTY_STRING,
        separator: DYNAMIC_DATA_SPLITTER
    },
    vWeightVlb: {
        row: 1,
        column: 6,
        splitBy: EMPTY_STRING,
        separator: DYNAMIC_DATA_SPLITTER
    }
};